// src/utils/referral.js
// 공유 링크의 ?ref=CODE 를 캡처해 보관 → 가입 시 자동 적용.
// 공유받은 영상 페이지(/video/:id?ref=CODE)로 들어와 나중에 /register 로 가도 코드가 유지되도록.

const KEY = 'cc.ref';

export function captureRef(search) {
  try {
    const raw = new URLSearchParams(search ?? window.location.search).get('ref');
    const code = (raw || '').trim();
    if (code) localStorage.setItem(KEY, code);
    return code || null;
  } catch {
    return null;
  }
}

export function getStoredRef() {
  try {
    return localStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

export function clearStoredRef() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
